module.exports = "<ngx-ui-loader hasProgressBar=\"false\" ></ngx-ui-loader>\r\n<router-outlet></router-outlet>\r\n"